import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import {
  ECOSHOTS_COMPLETED_PAGE_ROUTE,
  ECOSHOTS_PAGE_ROUTE,
  ECOSHOTS_PROCESSING_PAGE_ROUTE,
} from "../../../Routes";
import CompletedJobs from "./CompletedJobs";
import useStyles from "./EcoShotsPage.styles";
import ProcessingJobs from "./ProcessingJobs";

export default function EcoShotsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  useEffect(() => {
    document.title = "EcoShot Image Hub - EcoShot Images";
  }, []);

  if (location.pathname === ECOSHOTS_PAGE_ROUTE) {
    return <Navigate to={ECOSHOTS_COMPLETED_PAGE_ROUTE} replace />;
  }

  return (
    <div>
      <Paper square>
        <div className={classes.tabsContainer}>
          <div className={classes.tabHeader}>
            <AccessibilityIcon fontSize="small" />
            <Typography variant="h6">EcoShot Images</Typography>
          </div>
          <Tabs
            value={location.pathname}
            onChange={(_evt, route) => navigate(route)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Processing" value={ECOSHOTS_PROCESSING_PAGE_ROUTE} />
            <Tab label="Completed" value={ECOSHOTS_COMPLETED_PAGE_ROUTE} />
          </Tabs>
        </div>
      </Paper>
      <div className={classes.contentContainer}>
        <Routes>
          <Route path="/completed" element={<CompletedJobs />} />
          <Route path="/processing" element={<ProcessingJobs />} />
          <Route
            path="*"
            element={<Navigate to={ECOSHOTS_COMPLETED_PAGE_ROUTE} replace />}
          />
        </Routes>
      </div>
    </div>
  );
}
